<script>
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId");
import { Tag, Button } from "view-design";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "feedback",
        key: "id",
        url: {
          del: "/admin/system/feedback",
        },
        output: false,
      },
      filters: [
        {
          label: "反馈内容",
          name: "content",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      menus: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "反馈内容",
          key: "content",
          minWidth: 120,
          align: "left",
        },
        {
          title: "图片",
          key: "imgUrl",
          minWidth: 120,
          align: "center",
          viewimages: true,
        },
        {
          title: "类型",
          key: "type",
          minWidth: 50,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.type == 1
                ? "投诉"
                : row.type == 2
                ? "建议"
                : row.type == 3
                ? "其他"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          key: "handle",
          handle: [
            // 'edit',
            "delete",
          ],
          auth: {
            del: "admin/feedback/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: "feedback_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "feedback_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style scoped></style>
